import { IComponentController, IComponentOptions } from 'angular';

import templateUrl from './agent-booking-mail-inprocess-unit.component.ajs.html';

const MODULE_NAME = 'agentBookingMailInprocessUnit';

class AgentBookingMailInprocessUnitCtrl implements IComponentController {
  public name = MODULE_NAME;

  responseId: string;

  $onInit() {}
}

export class AgentBookingMailInprocessUnit implements IComponentOptions {
  templateUrl = templateUrl;
  bindings = {
    responseId: '<',
  } as { [binding: string]: string };
  controller = [AgentBookingMailInprocessUnitCtrl];
}

export default MODULE_NAME;
